// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"e21dc753","513":"ef01322b","703":"958107ca","787":"76689014"}[chunkId] + ".chunk.js";
};